module.exports = __webpack_public_path__ + "img/logo_xmiles_top-b.d12a409d.png";